export enum HandoverStateEnum {
  OPEN = "open",
  CLOSED = "closed"
}
